import { jsx as o, Fragment as u, jsxs as m } from "react/jsx-runtime";
import { isFunction as h } from "@waitroom/utils";
import { Fragment as l } from "react";
const E = (n, t = ", ") => {
  if (!n || !n.length) return "";
  const e = n.length;
  return /* @__PURE__ */ o(u, { children: n.map((i, r) => /* @__PURE__ */ m(l, { children: [
    i,
    r < e - 1 ? t : ""
  ] }, r)) });
}, p = (n, t, e) => {
  if (!n || !n.length) return "";
  const i = h(t) ? (c, f) => /* @__PURE__ */ o(l, { children: t(c, f) }, f) : (c) => c[t] || "", r = [...n].filter(Boolean), d = r.length;
  if (d <= 1) return /* @__PURE__ */ o(u, { children: r.map(i) });
  const S = r.pop();
  return /* @__PURE__ */ m(u, { children: [
    E(r.map(i)),
    " ",
    e,
    " ",
    i(S, d - 1)
  ] });
}, A = (n, t = 2) => Array(t).fill(null).map((e, i) => /* @__PURE__ */ o(l, { children: n }, i)), _ = (n, t) => typeof n == "function" ? n() : t(n);
function s(n) {
  return typeof n == "function" ? n : (...t) => {
    const e = { type: n, payload: t[0] };
    return t.length > 1 && (e.meta = t[1]), e;
  };
}
function $(n) {
  return {
    REQUEST: `${n}_REQUEST`,
    SUCCESS: `${n}_SUCCESS`,
    ERROR: `${n}_ERROR`,
    requestAction: s(
      `${n}_REQUEST`
    ),
    successAction: s(
      `${n}_SUCCESS`
    ),
    errorAction: s(`${n}_ERROR`)
  };
}
const C = (n, t) => n && n.reduce(
  (e, i) => {
    const r = String(i[t]);
    return e.ids.push(r), e.entities[r] = i, e;
  },
  {
    ids: [],
    entities: {}
  }
), U = (n) => {
  if (!(!n || !n.ids))
    return n.ids.reduce((t, e) => (t.push(n.entities[e]), t), []);
};
export {
  _ as callbackOrAction,
  s as createAction,
  U as denormalizeState,
  $ as generateActions,
  E as joinJsx,
  p as joinWithAndJsx,
  C as normalizeState,
  A as repeat
};
